export enum TimelineStateEnum {
  WaitingInit,
  Activated,
  Fullfilled,
  Expired,
  Reopened,
}
